import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { EstoqueService } from 'src/app/service/estoque.service';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { aplicarFiltrosConsulta, isFiltroIdNumerico } from 'src/app/util/consulta/wow-consulta.util';
import { Estoque } from './estoque';

@Component({
  selector: 'app-estoque-consulta',
  templateUrl: './estoque-consulta.component.html',
  styleUrls: ['./estoque.component.scss', '../../util/conta-financeira/conta-financeira-consulta.scss'],
})
export class EstoqueConsultaComponent {

  listEstoque: Estoque[] = [];
  ordemColunasTabela = ['id', 'createdAt', 'fornecedor', 'produto', 'qdtProduct', 'amountPaid', 'excluir', 'editar'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100];
  mensagemErros: String[] = [];
  consultaRealizada = false;
  tipoFiltros = ['ID', 'Produto', 'Fornecedor'];
  tipoFiltro = 'ID';
  parametro = '';

  constructor(
    private estoqueService: EstoqueService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
  ) { }

  consultar(resetPagina = true) {
    if (resetPagina) this.pagina = 0;
    const idFiltro = isFiltroIdNumerico(this.tipoFiltro, this.parametro);
    if (idFiltro != null) {
      this.estoqueService.findClientById(idFiltro).subscribe(item => {
        this.listEstoque = [item];
        this.totalElementos = 1;
        this.consultaRealizada = true;
      }, () => this.snackBar.open('Entrada não encontrada.', 'ERRO', { duration: 2500 }));
      return;
    }
    this.estoqueService.list(this.pagina, this.tamanho).subscribe(response => {
      const filtrados = aplicarFiltrosConsulta(response.content ?? [], this.tipoFiltro, this.parametro, null, {
        id: e => e.id,
        nome: e => this.tipoFiltro === 'Fornecedor' ? e.fornecedor : e.produto,
      });
      this.listEstoque = filtrados;
      this.totalElementos = this.parametro?.trim() ? filtrados.length : response.totalElements;
      this.pagina = response.number;
      this.consultaRealizada = true;
    });
  }

  novo() { this.router.navigate(['/estoque/form']); }
  editar(id: number) { this.router.navigate(['/estoque/form', id]); }

  paginar(event: PageEvent) {
    if (!this.consultaRealizada) return;
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.consultar(false);
  }

  openDialog(id: number) {
    this.dialog.open(ConfirmaDeleteComponent).afterClosed().subscribe(result => {
      if (result) this.excluir(id);
    });
  }

  private excluir(id: number) {
    this.estoqueService.delete(id).subscribe(() => {
      this.mensagemErros = [];
      this.snackBar.open('Entrada excluido com sucesso!', 'Sucesso', { duration: 2000 });
      this.consultar(false);
    }, errorResponse => {
      this.mensagemErros = ['Erro: ' + errorResponse.error.message];
    });
  }
}
